<template>
	<div>
		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<span class="m-form__help">Chọn game</span>
				<select :id="'gameSelection'+tab" class="gameSelection"></select>
			</div>
		</div>
		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<span class="m-form__help">Chọn đài</span>
				<select :id="'channelSelection'+tab" class="channelSelection" multiple="multiple"></select>
			</div>
		</div>
		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<span class="m-form__help">Chọn kiểu</span>
				<select :id="'propSelection'+tab" class="propSelection" multiple="multiple"></select>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	const select2opt = {
		width: '100%', 
		placeholder: 'Vui lòng chọn'
	};

	const propsInfo = {
		1: [1,2,4,6,7,9,11,12,14,15,16],
		2: [1,2,3,5,6,7,8,10,11,13,14,15,16],
		3: [17,18,19],
		4: [1,2,3,5,6,7,8,10,11,13,14,15,16],
	};

	export default {
		props: ['onlyToday', 'selectedRecord', 'tab'],

		data(){
			let vm = this;
			
	        return {
	            "channels": [],
	            "props": [],
	            "channelsByGame": [],
	            "gameData": []
	        }
	    },

    	mounted(){
    		this.initGameSelection();
    		this.groupChannelByGame();
    		this.initChosen();
    	},

    	watch: {

    	},

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	    	initGameSelection: function(){
	    		let ids = Object.keys(this.gameInfo.games);
	    		let data = ids.map((id) => { return {"id": id, "text": this.gameInfo.games[id]}; });
	    		data.unshift({"id": "", "text": ""});
	    		this.gameData = data;
	    	},

	    	_initPropSelection: function(game){
	    		let vm = this;
	    		let props = propsInfo[game].map((e) => { return { id: e, text: vm.gameInfo.props[e] }; });
	    		props.unshift({"id": "", "text": ""});
	    		this.props = props;
	    	},

	        initChosen: function() {
	        	let vm = this;

	        	$('#gameSelection'+this.tab).select2({...select2opt, data: this.gameData});
	        	$('#gameSelection'+this.tab).on('change.select2', function(e){
	        		let game = $("#gameSelection"+vm.tab).val();
	        		if(game == "") return;

	        		if(vm.onlyToday){
	        			vm._generateToday(game);
	        		}else{
	        			vm._generateAll(game);
	        		}

	        		let channelOpt = game == 1 ? {...select2opt, disabled: true} : {...select2opt, disabled: false, data: vm.channelsByGame}; 
	        		vm._initPropSelection(game);

	        		$('#channelSelection'+vm.tab).select2("destroy");
	        		$('#channelSelection'+vm.tab).html("");
    				$('#channelSelection'+vm.tab).select2(channelOpt);

    				$('#propSelection'+vm.tab).select2("destroy");
    				$('#propSelection'+vm.tab).html("");
    				$('#propSelection'+vm.tab).select2({...select2opt, data: vm.props});

    				// if(vm.selectedRecord){
    				// 	let c = vm._generateSelectedChannel(vm.selectedRecord.channel_id);
	    			// 	$('#channelSelection').val(c).trigger('change');
	    			// 	$('#propSelection').val(vm.selectedRecord.prop_id).trigger('change');
	       //  		}
	        	});

	        	$('#channelSelection'+this.tab).select2(select2opt);
	        	$('#propSelection'+this.tab).select2(select2opt);

	        	// if(vm.selectedRecord) $('#gameSelection').val(vm.selectedRecord.game_id).trigger('change');
	        },

	        groupChannelByGame: function() {
	        	let channels  = {};
	        	for(let i in this.gameInfo.channels){
	        		let channel = this.gameInfo.channels[i];

	        		if(!channels[channel.game_id]) channels[channel.game_id] = [];
	        		channels[channel.game_id].push(channel);
	        	}

	        	this.channels = channels;
	        },

	        _generateToday: function(game){
	        	let vm = this;
	        	let data = [];

	        	if(game == 3){
        			data = vm.gameInfo.channelToday[game].map((el) => {
        				let chns = el.channel_id.split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
        				return { id: el.channel_id, text: chns.join(", ") };
        			});
        		}else{
        			data = vm.gameInfo.channelToday[game].map((el) => {
        				return { id: el.channel_id, text: vm.gameInfo.channels[parseInt(el.channel_id)].alias };
        			});
        		}

        		data.unshift({"id": "", "text": ""});
        		vm.channelsByGame = data;
	        },

	        _generateAll: function(game){
	        	let vm = this;
	        	let data = [];

	        	if(game == 3){
        			data = vm.gameInfo.xienChannels.map((e) => {
        				return {
        					"id": e,
        					"text": e.split(".").map((el) => { return vm.gameInfo.channels[el].alias; }).join(" - ")
        				}
        			});
        		}else{
        			data = vm.channels[game].map((e) => { return { "id": e.id, "text": e.alias } });
        		}

        		data.unshift({"id": "", "text": ""});
        		vm.channelsByGame = data;
	        },

	    }
	}

</script>